import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { DeliveryMethodResource } from "@exonn/js-sdk";

export const module: ModuleOptions<DeliveryMethodResource> = {
  resource: ResourceEnum.DeliveryMethod,
  bigIcon: <span className={"icon-20-deliv_metd"} />,
  smallIcon: <span className={"icon-15-deliv_metd"} />,
};
